import { render, staticRenderFns } from "./ModalEula.vue?vue&type=template&id=90e230f4&scoped=true&"
import script from "./ModalEula.vue?vue&type=script&lang=js&"
export * from "./ModalEula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e230f4",
  null
  
)

export default component.exports